module.exports = __webpack_public_path__ + "../resources/img/Icon_Arrow_Left.200dcb95.svg";